import type { Metric } from "web-vitals";

const VITALS_URL = "https://vitals.vercel-insights.com/v1/vitals";

function getConnectionSpeed(): string {
  const nav = navigator as Navigator & {
    connection?: { effectiveType?: string };
  };
  return nav.connection?.effectiveType ?? "";
}

function sendToAnalytics(metric: Metric) {
  const body = {
    dsn: import.meta.env.VITE_VERCEL_ANALYTICS_ID || "",
    id: metric.id,
    page: window.location.pathname,
    href: window.location.href,
    event_name: metric.name,
    value: metric.value.toString(),
    speed: getConnectionSpeed(),
  };

  const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(VITALS_URL, blob);
  }
}

export function reportWebVitals() {
  import("web-vitals").then(({ onCLS, onFID, onLCP, onFCP, onTTFB, onINP }) => {
    onCLS(sendToAnalytics);
    onFID(sendToAnalytics);
    onLCP(sendToAnalytics);
    onFCP(sendToAnalytics);
    onTTFB(sendToAnalytics);
    onINP(sendToAnalytics);
  });
}
